import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import { authAPI } from "../../api/auth";
import { FaEnvelope, FaMobileAlt, FaArrowLeft } from "react-icons/fa";
import Swal from "sweetalert2";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    email_or_mobile: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await authAPI.forgotPassword(formData);

      // Show demo OTP for testing
      Swal.fire({
        icon: "success",
        title: "OTP Sent!",
        html: `
          <div>
            <p>${response.data.message}</p>
            <p><strong>Demo OTP : ${response.data.otp_demo || ""}</strong></p>
          </div>
        `,
        timer: 5000,
        showConfirmButton: true,
      });

      setSuccess(true);
      setTimeout(() => {
        navigate("/reset-password", {
          state: { email_or_mobile: formData.email_or_mobile },
        });
      }, 2000);
    } catch (error) {
      console.error("Forgot password error:", error);
      setError(error.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="auth-container">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col md={6} lg={4}>
          <div className="text-center mb-4">
            <Link
              to="/login"
              className="text-decoration-none d-inline-flex align-items-center mb-3"
            >
              <FaArrowLeft className="me-2" /> Back to Login
            </Link>
            <h1 className="display-6 fw-bold text-primary">
              <span className="text-warning">V</span>Shape Gym
            </h1>
            <p className="text-muted">Recover your password</p>
          </div>

          <Card className="shadow-lg border-0">
            <Card.Body className="p-4">
              {error && (
                <Alert
                  variant="danger"
                  onClose={() => setError("")}
                  dismissible
                >
                  {error}
                </Alert>
              )}

              {success ? (
                <Alert variant="success">
                  <h5 className="alert-heading">OTP Sent Successfully!</h5>
                  <p>
                    Check your registered email/mobile for the OTP. Redirecting
                    to reset password...
                  </p>
                </Alert>
              ) : (
                <>
                  <div className="text-center mb-4">
                    <div className="mb-3">
                      <div className="forgot-password-icon mx-auto">
                        <FaEnvelope size={48} className="text-primary" />
                      </div>
                    </div>
                    <h5>Forgot Password?</h5>
                    <p className="text-muted">
                      Enter your registered email or mobile number to receive
                      OTP
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label>Email or Mobile Number</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaEnvelope />
                        </span>
                        <Form.Control
                          type="text"
                          name="email_or_mobile"
                          value={formData.email_or_mobile}
                          onChange={handleChange}
                          placeholder="user@gmail.com or 9876543210"
                          required
                        />
                      </div>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Send OTP"}
                    </Button>
                  </Form>
                </>
              )}

              <div className="text-center mt-3">
                <span className="text-muted">Remember your password? </span>
                <Link to="/login" className="text-decoration-none fw-bold">
                  Login here
                </Link>
              </div>
            </Card.Body>
          </Card>

          <div className="text-center mt-4">
            <div className="alert alert-info">
              <small>
                <FaMobileAlt className="me-1" />
                <strong>Note:</strong> For demo purposes, OTP will be displayed
                on screen. In production, it will be sent to your registered
                email/mobile.
              </small>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
